import axios from '@/utils/request'   //报销核销
/**
 * 设置
 */
// 核销奖励设置
export const setWrite = (data)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/setWrite',
    method: 'post',
    data
  })
};
 // 核销奖励设置获取
export const getWrite = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/getWrite',
    method: 'get',
    params
  })
};
 
//报销设置
export const setReimbursement = (data)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/setReimbursement',
    method: 'post',
    data
  })
};
//报销设置获取
export const getReimbursement = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/getReimbursement',
    method: 'get',
    params
  })
};

/**
 * 意见反馈
 */

//意见反馈列表
export const getFeedbackList = (params)=>{
  return axios.request({
    url: 'v1/feedback/index',
    method: 'get',
    params
  })
};
//意见反馈详情
export const getFeedbackMore = (params)=>{
  return axios.request({
    url: 'v1/feedback/detail',
    method: 'get',
    params
  })
};
//意见反馈修改
export const feedbackEdit = (data)=>{
 return axios.request({
  url: 'v1/feedback/update',
  method: 'post',
  data
  })
};
//意见反馈删除
export const feedbackDel = (data)=>{
 return axios.request({
  url: 'v1/feedback/del',
  method: 'post',
  data
  })
};

/**
 * 资产
 */

//资产明细
export const getAssetsList = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/assetsStatistics',
    method: 'get',
    params
  })
};
//资产明细详情
export const getAssetsMoreCoupon = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/assetsCoupon',
    method: 'get',
    params
  })
};
//资产明细-礼品
export const getAssetsMoreGift = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/assetsGift',
    method: 'get',
    params
  })
};
//积分账单
export const getAssetsPointBill = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/pointBill',
    method: 'get',
    params
  })
};

/**
 * 报销单
 */

//报销单审批列表
export const getReimbursmentSingle = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/getReimbursmentSingle',
    method: 'get',
    params
  })
};
//报销单详情
export const getReimbursmentSingleDetails = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/getReimbursmentSingleDetails',
    method: 'get',
    params
  })
};
//报销单详情 优惠券列表
export const getReimbursmentSingleCoupon = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/getCouponList',
    method: 'get',
    params
  })
};
//报销单详情 礼品列表
export const getReimbursmentSingleGift = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/getGiftList',
    method: 'get',
    params
  })
};
//报销单 审核
export const reimbursmentAudit = (data)=>{
  return axios.request({
   url: 'reimbursement/reimbursement/audit',
   method: 'post',
   data
   })
 };
//手动报销
export const addReimbursment = (data)=>{
  return axios.request({
   url: 'reimbursement/reimbursement/addReimbursmentSingle',
   method: 'post',
   data
   })
 };
//手动报销 优惠券列表
export const addReimbursmentCoupon = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/reimbursementCoupon',
    method: 'get',
    params
  })
};
//手动报销 礼品列表
export const addReimbursmentGift = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/assetsGift',
    method: 'get',
    params
  })
};
//手动报销 积分
export const addReimbursmentPoint = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/getStorePoint',
    method: 'get',
    params
  })
};
//报销单 审批超时是否查看
export const getLookOver = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/getLookOver',
    method: 'get',
    params
  })
};
//报销单 设置是否超时
export const setLookOver = (data)=>{
  return axios.request({
   url: 'reimbursement/reimbursement/setLookOver',
   method: 'post',
   data
   })
 };
 /**
 * 核销管理
 */

//订单积分
export const getWriteOrderPoint = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/orderPoint',
    method: 'get',
    params
  })
};
//优惠券
export const getWriteCoupon = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/writeCouponList',
    method: 'get',
    params
  })
};
//礼品
export const getWriteGift = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/writeGift',
    method: 'get',
    params
  })
};
//手动报销 可报销的门店
export const getReimbursementStore = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/getStoreList',
    method: 'get',
    params
  })
};
//手动报销 可报销的经销商
export const getReimbursementDealer = (params)=>{
  return axios.request({
    url: 'reimbursement/reimbursement/getDealerList',
    method: 'get',
    params
  })
};

//消费者核销明细/门店核销权益卡礼品明细
export const writeList = (params)=>{
  return axios.request({
    url: 'v2/profit/writeList',
    method: 'get',
    params
  })
};
